import { api } from "./urlApi";

export const login = async (credenciales) => {
  const url = `${api}/auth/login.php`;

  try {
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify(credenciales),
    });

    const token = await resp.json();

    return token;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expirationToken");
  window.location.href = "/login";
};

export const isLogin = async () => {
  const token = localStorage.getItem("token");
  //convertir a string el token
  const url = `${api}/auth/isLogin.php`;

  try {
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ token }),
    });

    const { isLogged } = await resp.json();
    return isLogged;
  } catch (error) {
    console.log(error);
    return false;
  }
};
